import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NeverAttendedService {

  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/neverAttended";

  url2 = environment.serverAPI4 + "/api/notPickupByClient";

  LeadNeverAttended(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery?: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      "additionalQuery": additionalQuery
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  LeadNeverAttendedExcel(query: string, page: number, size: number, sort: string, groupBy: any, columnsConfig: any): Observable<any> {
    return this.LeadNeverAttended(query, page, size, sort, groupBy).pipe(
      map((res: any) => {
        let content = res['content'];
        if (content && columnsConfig && Array.isArray(columnsConfig)) {
          res['content'] = content.map((item: any) => {
            item.daysSinceLastAttempt = this.calculateDaysSince(item.lastAttemptedDate);
            let newItem: any = {};
            for (let col of columnsConfig) {
              newItem[col.name] = item[col.property];
            }
            return newItem;
          });
        }
        return res;
      })
    );
  }

  private calculateDaysSince(dateStr: any): any {
    if (!dateStr) return '--';
    const lastAttempt = new Date(dateStr);
    if (isNaN(lastAttempt.getTime())) return '--';
    const today = new Date();
    const date1 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    const date2 = Date.UTC(lastAttempt.getFullYear(), lastAttempt.getMonth(), lastAttempt.getDate());
    const diffDays = Math.floor((date1 - date2) / (1000 * 60 * 60 * 24));
    return diffDays >= 0 ? diffDays : 0;
  }

  notPickupByClient(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url2}/condition${queryParams}`, requestBody);
  }

  notPickupByClientExcel(query: string, page: number, size: number, sort: string, groupBy: any, columnsConfig: any): Observable<any> {
    return this.notPickupByClient(query, page, size, sort, groupBy).pipe(
      map((res: any) => {
        let content = res['content'];
        if (content && columnsConfig && Array.isArray(columnsConfig)) {
          res['content'] = content.map((item: any) => {
            let newItem: any = {};
            for (let col of columnsConfig) {
              newItem[col.name] = item[col.property];
            }
            return newItem;
          });
        }
        return res;
      })
    );
  }

}
